import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export default (app: App, router: Router) => {
    if (!import.meta.env.VITE_SENTRY_DSN) {
        return;
    }

    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracePropagationTargets: [
                    'localhost',
                    'keyvue.nl',
                    /^\//,
                ],
            }),
        ],

        release: APP_VERSION,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
};
